import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TeacherWithStudentsIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 23.703 14.848",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 14.848),
    children: [/*#__PURE__*/jsx("path", {
      d: "m13.462 10.444a1.69 1.69 0 1 0 .495-1.2 1.69 1.69 0 0 0 -.495 1.2zm-5.316 0a1.69 1.69 0 1 0 .494-1.2 1.69 1.69 0 0 0 -.494 1.2zm10.514 0a1.69 1.69 0 1 0 1.686-1.691 1.69 1.69 0 0 0 -1.69 1.69zm4.341 3.7a3.368 3.368 0 0 0 -5.244 0 3.5 3.5 0 0 0 -2.668-1.251m-7.91 1.252a3.368 3.368 0 0 1 5.244 0 3.5 3.5 0 0 1 2.668-1.251"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.483 8.575a2.99 2.99 0 1 0 -5.98 0v2.093h1.492l.3 3.587h2.388l.3-3.588m-3.584-8.074a2.093 2.093 0 1 0 2.093-2.093 2.093 2.093 0 0 0 -2.093 2.093z"
    })]
  });
};

export { PM2TeacherWithStudentsIcon };
//# sourceMappingURL=teacher-with-students.js.map
